'use client'

import { useEffect } from 'react'
import { useTranslations } from 'next-intl'

import { LAYOUT_TEST_IDS } from '@common/common-test-ids.const'

import { useWorkspaceSettings } from '@modules/settings/workspace/hooks'
import { useWorkspacesStore } from '@modules/workspaces'
import { selectInviteWorkspaceDialogOpen } from '@stores/layout/layout.selector'
import { useLayoutStore } from '@stores/layout/layout.store'

import { MembersInviteDialog } from '../../MembersInviteDialog'
import { useLayoutInviteHandlers } from '../hooks/useLayoutInviteHandlers'

export function WorkspaceInviteDialogContainer() {
  const t = useTranslations('core')
  const open = useLayoutStore(selectInviteWorkspaceDialogOpen)
  const setInviteWorkspaceDialogOpen = useLayoutStore((state) => state.setInviteWorkspaceDialogOpen)
  const currentWorkspace = useWorkspacesStore((state) => state.currentWorkspace)
  const { inviteProjectMember, inviteWorkspaceMember, getWorkspaceMembers, members } = useWorkspaceSettings()
  const { handleInviteWorkspace } = useLayoutInviteHandlers({ inviteProjectMember, inviteWorkspaceMember })

  useEffect(() => {
    if (!open) {
      return
    }

    void getWorkspaceMembers()
  }, [getWorkspaceMembers, open])

  return (
    <div data-testid={LAYOUT_TEST_IDS.workspaceInviteDialogContainer} style={{ display: 'contents' }}>
      <MembersInviteDialog
        open={open}
        onOpenChange={setInviteWorkspaceDialogOpen}
        contextName={currentWorkspace?.name ?? ''}
        onInvite={handleInviteWorkspace}
        membersForValidation={members}
        conflictAlreadyMemberMessage={t('inviteToWorkspaceDialog.conflictAlreadyMember')}
        conflictAlreadyInvitedMessage={t('inviteToWorkspaceDialog.conflictAlreadyInvited')}
        title={t('inviteToWorkspaceDialog.title')}
        descriptionPre={t('inviteToWorkspaceDialog.descriptionPre')}
        descriptionMid={t('inviteToWorkspaceDialog.descriptionMid')}
        descriptionPost={t('inviteToWorkspaceDialog.descriptionPost')}
        emailInvalidMessage={t('inviteToWorkspaceDialog.emailInvalid')}
        placeholder={t('inviteToWorkspaceDialog.emailPlaceholder')}
        roleDeveloperLabel={t('inviteToWorkspaceDialog.roleDeveloper')}
        roleAdminLabel={t('inviteToWorkspaceDialog.roleAdmin')}
        cancelLabel={t('inviteToWorkspaceDialog.cancel')}
        confirmLabel={t('inviteToWorkspaceDialog.invite')}
      />
    </div>
  )
}
